// Datos legales centralizados — editar aquí afecta a privacidad, términos, cookies y aviso legal
export const LEGAL = {
  brand: "Strato",
  domain: "stratoapp.online",
  legalName: "ALBA BAENA RUIZ LTDA.",
  country: "Brasil",
  contactEmail: "albabaenastudio@gmail.com",
  effectiveDate: "23 de mayo de 2026",
  pricingMonthly: "USD 6 / mes",
  pricingYearly: "USD 49 / año",
  trialDays: 5,
};
